module.exports = __webpack_public_path__ + "media/images/emblems/Wiler_bei_Utzenstorf-coat_of_arms-73abdc7611f4d122d191dba1d74fdc85.svg";